module.exports = __webpack_public_path__ + "assets/img/79ea6f3fb8ed63f55f8332de57938aa8.png";